"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHydrate = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const ssr_redux_context_1 = require("../context/ssr-redux-context");
const ssr_api_context_1 = require("../context/ssr-api-context");
const querystring_helper_1 = require("../helpers/querystring.helper");
const redux_store_1 = require("../redux/redux.store");
const vars_1 = require("../constants/vars");
const withHydrate = (component, cfg) => {
    if (global.window) {
        const state = global.window[vars_1.APP_VAR][vars_1.APP_INIT];
        const redux = (0, redux_store_1.create)(cfg.reducers || {}, state);
        const config = global.window[vars_1.APP_VAR][vars_1.APP_CONFIG];
        const ctx = {
            logger: global.window.console,
            getHost: () => global.window.location.host,
            getPath: () => global.window.location.pathname,
            getQuery: () => (0, querystring_helper_1.parse)(global.window.location.search),
            getDevice: () => config.device
        };
        const body = react_1.default.createElement(component, state);
        const apiContext = react_1.default.createElement(ssr_api_context_1.SSRApiContext.Provider, { value: ctx }, body);
        const reduxContext = react_1.default.createElement(ssr_redux_context_1.SSRReduxContext.Provider, { value: redux }, apiContext);
        react_dom_1.default.hydrate(reduxContext, typeof cfg.root === 'string' ? document.querySelector(cfg.root) : cfg.root);
    }
    return component;
};
exports.withHydrate = withHydrate;
//# sourceMappingURL=hydrate.wrapper.js.map